export const FETCH_ALL_PROMOTION = 'fetch_all_promotion';
export const FETCH_ALL_PROMOTION_SUCCESS = 'fetch_all_promotion_success';
export const EDIT_PROMOTION = 'edit_promotion';
export const DELETE_PROMOTION = 'delete_promotion';
export const CREATE_PROMOTION = 'create_promotion';
export const CREATE_PROMOTION_SUCCESS = 'create_promotion_success';
export const UPDATE_PROMOTION_SUCCESS = 'update_promotion_success';
export const UPDATE_PROMOTION = 'update_promotion';
export const DELETE_PROMOTION_SUCCESS = 'delete_promotion_success';
export const SET_PROMOTION = 'set_promotion';
export const SET_ROLE = 'set_role';